import { Http } from '@angular/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { UtilsService } from './utils.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
import * as i2 from "./utils.service";
var NewsfeedService = /** @class */ (function () {
    function NewsfeedService(http, _utilsService) {
        this.http = http;
        this._utilsService = _utilsService;
    }
    NewsfeedService.prototype.getPosts = function (user_id, filters, page, search, save, lgId, tourId, pageName) {
        if (page === void 0) { page = 1; }
        if (search === void 0) { search = ''; }
        if (save === void 0) { save = false; }
        if (pageName == 'lgProfile') {
            return this._utilsService.getRequest("" + environment.phpApiUrl + '/user_posts/get-league-post/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + parseInt(lgId) + '/' + user_id + '/' + parseInt(tourId) + '/' + page);
        }
        else {
            var filter_data_1 = {
                feedtext_search: search,
                feed_type: filters.feed_type.split(','),
                apply_lobby_filter: (save) ? 1 : 0,
                game_type: filters.game_type.split(',')
            };
            filters.news_priority.split(',').forEach(function (game) {
                var data = game.split('|');
                if (data.length == 2)
                    filter_data_1['priority_' + data[0]] = parseInt(data[1]);
            });
            var data = {
                access_token: "" + environment.DRAFT_ACCESS_TOKEN,
                user_uuid: parseInt(user_id),
                page_no: page,
                filter_data: filter_data_1,
                league_id: parseInt(lgId),
                tournament_id: parseInt(tourId)
            };
            return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/filter_app', data, null, 'content-type-json');
        }
    };
    NewsfeedService.prototype.likePost = function (user_uuid, post_uuid, posted_by_uuid, like_status, display_name) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            user_uuid: user_uuid,
            post_uuid: post_uuid,
            posted_by_uuid: posted_by_uuid,
            like_status: like_status,
            display_name: display_name
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/like-dislike', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.likeComment = function (user_uuid, post_uuid, like_status, display_name) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            user_uuid: user_uuid,
            post_uuid: post_uuid,
            like_status: like_status,
            display_name: display_name
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/like-dislike-comment', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.loadMoreComments = function (post_id, cursor, user_id, totalComment) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            post_id: post_id,
            cursor: cursor,
            user_id: user_id,
            lastCommentId: 0,
            totalComment: totalComment
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/load_more_comment', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.getPoll = function (poll_id, user_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/feed/getPoll/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + poll_id + '/' + user_id);
    };
    NewsfeedService.prototype.getPollVoters = function (poll_id, choice) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/feed/getPollVoters/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + poll_id + '/' + choice);
    };
    NewsfeedService.prototype.votePoll = function (poll_id, user_id, choice) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/feed/votePoll/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + poll_id + '/' + user_id + '/' + choice);
    };
    NewsfeedService.prototype.createPoll = function (user_id, question, options) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            user_id: user_id,
            question: question,
            options: options
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/feed/createPoll', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.makePost = function (user_uuid, status_detail, post_type, user_display_name, push_notification, fantasy_league_id, tournament_id, summary, league_name, league_type, parent_post_id, info, content, privacy, image) {
        if (push_notification === void 0) { push_notification = null; }
        if (fantasy_league_id === void 0) { fantasy_league_id = null; }
        if (tournament_id === void 0) { tournament_id = null; }
        if (summary === void 0) { summary = null; }
        if (league_name === void 0) { league_name = null; }
        if (league_type === void 0) { league_type = null; }
        if (parent_post_id === void 0) { parent_post_id = null; }
        if (info === void 0) { info = null; }
        if (content === void 0) { content = null; }
        if (privacy === void 0) { privacy = null; }
        if (image === void 0) { image = null; }
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            user_uuid: user_uuid,
            status_detail: status_detail,
            post_type: post_type,
            user_display_name: user_display_name,
            fantasy_league_id: (fantasy_league_id) ? parseInt(fantasy_league_id) : null,
            tournament_id: (tournament_id) ? parseInt(tournament_id) : null,
            summary: summary,
            league_name: league_name,
            league_type: league_type,
            parent_post_id: parent_post_id,
            info: info,
            content: content,
            privacy: privacy,
            image: image,
            push_notification: push_notification
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/addnewpost', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.makeComment = function (user_uuid, post_uuid, display_name, comment) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            user_uuid: user_uuid,
            post_uuid: post_uuid,
            display_name: display_name,
            comment: comment
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/add-comment', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.searchGiphy = function (search, offset, limit) {
        var key = 'nk28OLJ1XsDBaCt8CsKILEikos7zQt9g';
        var url = 'https://api.giphy.com/v1/gifs/search?api_key=' + key + '&q=' + encodeURIComponent(search) + '&limit=' + limit + '&offset=' + offset;
        return this.http
            .get(url, {})
            .pipe(map(function (res) { return res.json(); }));
    };
    NewsfeedService.prototype.postLikeList = function (post_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user_posts/user_like_list/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/like/' + post_id);
    };
    NewsfeedService.prototype.commentLikeList = function (comment_id) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/user_posts/comment_like_list/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/like/' + comment_id);
    };
    NewsfeedService.prototype.pollLikeList = function (poll_id, choice) {
        return this._utilsService.getRequest("" + environment.phpApiUrl + '/feed/getPollVoters/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + poll_id + '/' + choice);
    };
    NewsfeedService.prototype.deletePost = function (user_uuid, post_uuid, role_type) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            user_uuid: user_uuid,
            post_uuid: post_uuid,
            role_type: role_type
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/delete-post', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.hidePost = function (user_uuid, post_uuid) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            user_uuid: user_uuid,
            post_uuid: post_uuid
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/hide-post', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.pinPost = function (role_type, post_uuid, status) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            role_type: role_type,
            post_uuid: post_uuid,
            status: status
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/pin-post', data, null, 'content-type-json');
    };
    NewsfeedService.prototype.deleteComment = function (user_uuid, comment_id, role_type) {
        var data = {
            access_token: "" + environment.DRAFT_ACCESS_TOKEN,
            user_uuid: user_uuid,
            comment_id: comment_id,
            role_type: role_type
        };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/user_posts/delete-comment', data, null, 'content-type-json');
    };
    NewsfeedService.ngInjectableDef = i0.defineInjectable({ factory: function NewsfeedService_Factory() { return new NewsfeedService(i0.inject(i1.Http), i0.inject(i2.UtilsService)); }, token: NewsfeedService, providedIn: "root" });
    return NewsfeedService;
}());
export { NewsfeedService };
